import { PollService } from '../../services/poll.service';
import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { UserService } from '../../services/user.service';
import { JobOffersService } from '../../services/job-offers.service';
import { FormService } from '../../services/form.service';
import { VenueService } from '../../services/venue.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { TypeEventService } from '../../services/type-event.service';
import { EventService } from '../../services/event.service';
import { ReminderService } from '../../services/reminder.service';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.css']
})
export class ConfirmDeleteDialogComponent implements OnInit {
  @Input() UserID;
  @Input() OfferID;
  @Input() ApplyStatusID;
  @Input() VenueID;
  @Input() OfferStatus;
  @Input() FormID;
  @Input() PollID;
  @Input() FormStatus;
  @Input() PollStatus;
  @Input() TypeEventID;
  @Input() EventID;
  @Input() ReminderID;
  deleteUser: boolean = false;
  deleteVenue: boolean = false;
  deleteOffer: boolean = false;
  deleteApplyStatus: boolean = false;
  deleteForm: boolean = false;
  deletePoll: boolean = false;
  deleteTypeEvent: boolean = false;
  deleteEvent: boolean = false;
  deleteReminder: boolean = false;
  publicating: boolean = false;
  confirm_delete_message_tittle: string = "Confirmar Eliminar"
  confirm_delete_message: string = "¿Está seguro desea eliminar?";
  errorMessage: string;
  users: any;

  constructor(
    public dialogRef: MdDialogRef<ConfirmDeleteDialogComponent>,
    public userService: UserService,
    public venueService: VenueService,
    public applyStatusService: ApplyStatusService,
    private jobService: JobOffersService,
    private formService: FormService,
    private typeEventService: TypeEventService,
    private eventService: EventService,
    private pollService: PollService,
    private reminderService: ReminderService
  ) { }

  ngOnInit() {
  }

  onDelete() {
    if (this.deleteUser) {
      this.onDeleteUser();
    } else if (this.deleteOffer) {
      this.onDeleteOffer();
    } else if (this.deleteForm) {
      this.onDeleteForm();
    } else if (this.deleteVenue) {
      this.onDeleteVenue();
    } else if (this.deleteApplyStatus) {
      this.onDeleteApplyStatus();
    } else if (this.deleteTypeEvent) {
      this.onDeleteTypeEvent();
    } else if (this.deleteEvent) {
      this.onDeleteEvent();
    } else if (this.deleteReminder) {
      this.onDeleteReminder();
    } else if (this.deletePoll) {
      this.onDeletePoll();
    }
  }

  onDeleteVenue() {
    this.publicating = true;
    this.venueService.deleteVenues(this.VenueID)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close(this.VenueID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeletePoll() {
    this.publicating = true;
    this.pollService.deletePoll(this.PollID)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close(this.PollID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteApplyStatus() {
    this.publicating = true;
    this.applyStatusService.deleteApplyStatus(this.ApplyStatusID)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close(this.ApplyStatusID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteUser() {
    this.publicating = true;
    this.userService.deleteUser(this.UserID)
      .subscribe(
        data => {
          this.users = data;
          this.publicating = false;
          this.dialogRef.close(this.UserID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteOffer() {
    this.publicating = true;
    this.jobService.putOffersStatus(this.OfferID, this.OfferStatus)
      .subscribe(
        data => {
          this.users = data;
          this.publicating = false;
          this.dialogRef.close(this.OfferID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteForm() {
    this.publicating = true;
    this.formService.putFormStatus(this.FormID, this.FormStatus)
      .subscribe(
        data => {
          this.users = data;
          this.publicating = false;
          this.dialogRef.close(this.FormID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteTypeEvent() {
    this.publicating = true;
    this.typeEventService.deleteTypeEvent(this.TypeEventID)
      .subscribe(
        data => {
          this.users = data;
          this.publicating = false;
          this.dialogRef.close(this.TypeEventID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteEvent() {
    this.publicating = true;
    this.eventService.deleteEvent(this.EventID)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close(this.EventID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  onDeleteReminder() {
    this.publicating = true;
    this.reminderService.deleteReminder(this.ReminderID)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close(this.ReminderID);
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/confirm-delete-dialog/confirm-delete-dialog.component.ts